import * as CompaniesEmployeeService from "../../../services/companiesServices/CompaniesEmployeesService";
import * as FacilitiesService from "../../../services/companiesServices/CompaniesService";
import * as CompaniesEmployeesService from "../../../services/companiesServices/CompaniesEmployeesService";
import {getAllLocationsFromCompany} from "../../../services/companiesServices/CompaniesLocationsService";
import {getAllRolesFromCompany} from "../../../services/companiesServices/CompaniesRolesService";
import {
    editEmployeeById,
    getAllEmployeesFromCompany,
    getEmployeeById
} from "../../../services/companiesServices/CompaniesEmployeesService";
import * as FileService from "../../../services/FilesService";



export const getAllAvailableFacilityEmployeesHandler = async (facilityId) => {
    const response = await CompaniesEmployeesService.getAllEmployees();
    let allFacilityEmployees = null;
    let error = null;
    if (response.ok) {
        allFacilityEmployees = response.data.filter(e => e.facilities.indexOf(facilityId) < 0).map(r => {
            return {
                id: r.id,
                firstName: r.firstName,
                lastName: r.lastName,
                phone: r.phone,
                email: r.email,
                facility: r.facility,
                type: r.type,
            }

        });
    } else {
        error = "Error getAllServiceProvidersHandler";
    }

    return {
        data: {
            error: error,
            allFacilityEmployees: allFacilityEmployees
        }
    };


}

export const getCompanyByIdHandler = async (facilityId) => {
    const response = await FacilitiesService.getCompanyById(facilityId);

    let facility = null;
    let error = null;
    if (response.ok) {
        facility = {
            id: response.data.id,
            name: response.data.name,
            employees: response.data.employees.map(employee => {
                return {
                    id: employee.id,
                    firstName: employee.firstName,
                    lastName: employee.lastName,
                    roles: [employee.type]
                }
            })

        }

    } else {
        error = "Error getAllEmployeesByFacilityIdHandler";
    }

    return {
        data: {
            error: error,
            facility: facility
        }
    };
}


export const getAllLocationsForCompanyHandler = async (companyId) => {
    let error = null;
    const response = await getAllLocationsFromCompany(companyId);
    if (!response.ok) {
        return {
            data: {
                error: "Error getEmployeeByIdHandler",
            }
        }
    }

    const locations = response.data;
    return {
        data: {
            error: null,
            locations: locations
        }
    };

}

export const getAllRolesForCompany = async (companyId) => {
    let error = null;
    const rolesResponse = await getAllRolesFromCompany(companyId);

    if (!rolesResponse.ok) {
        return {
            data: {
                error: "Error getAllRolesForCompany",
            }
        }
    }
    const roles = rolesResponse.data.map(role => {
        return {
            id: role.id,
            companyId: role.companyId,
            name: role.name,
        }
    })

    return {
        data: {
            error: null,
            roles: roles
        }
    };
}

export const getAllLocationsAndRolesForCompanyHandler = async (companyId) => {
    let error = null;
    const rolesResponse = await getAllRolesFromCompany(companyId);
    const locationsResponse = await getAllLocationsFromCompany(companyId);
    if (!rolesResponse.ok || !locationsResponse.ok) {
        return {
            data: {
                error: "Error getAllLocationsAndRolesForCompany",
            }
        }
    }
    const roles = rolesResponse.data.map(role => {
        return {
            id: role.id,
            companyId: role.companyId,
            name: role.name,
        }
    })

    const locations = locationsResponse.data.map(location => {
        return {
            id: location.id,
            companyId: location.companyId,
            name: location.name,
            address: location.address,
            places: location.places,
        }
    })


    return {
        data: {
            error: null,
            roles: roles,
            locations: locations

        }
    };
}


export const getCompanyEmployeeByIdHandler = async (id) => {
    let error = null;
    const response = await getEmployeeById(id);
    if (!response.ok) {
        return {
            data: {
                error: "Error getEmployeeByIdHandler",
            }
        }
    }
    const account = {
        id: response.data.id,
        type: response.data.type,
        firstName: response.data.firstName,
        lastName: response.data.lastName,
        email:response.data.email,
        phone: response.data.phone,
        managedRoles: response.data.managedRoles,
        managedLocations: response.data.managedLocations,
        clockingLocations: response.data.clockingLocations,
        roles: response.data.roles,
        includeInReports: typeof(response.data.includeInReports) === "undefined"? true:response.data.includeInReports,
        deviceId:response.data.deviceId,
         signature: response.data.signature,
    }

    return {
        data: {
            error: null,
            account:account
        }
    };
}


export const createCompanyEmployeeHandler = async (data) => {
    let error = null;

    const body = {
        "companyId": data.companyId,
        "firstName": data.firstName,
        "lastName": data.lastName,
        "phone": data.phone,
        "password": data.password,
        "clockingLocations": data.clockingLocations,
        "roles": data.roles,
        "type": data.type,
        "managedLocations": data.managedLocations,
        "managedRoles": data.managedRoles,
        "includeInReports":data.includeInReports
    }
    const response = await CompaniesEmployeeService.createEmployee(body);
    let employeeId = null;

    if (response.ok) {
        employeeId = response.data.id
    } else {
        error = response.data.error;

    }

    return {
        data: {
            error: error,
            message:response.data.message,
            id: employeeId
        }
    };
}

export const editCompanyEmployeeByIdHandler = async (employeesArray) => {
    let error = null;
    const body = employeesArray.map(data => {
        return {
            "employeeId":data.employeeId,
            "firstName": data.firstName,
            "lastName": data.lastName,
            "phone":data.phone,
             "email":data.email,
            "password": data.password,
            "clockingLocations": data.clockingLocations,
            "roles": data.roles,
            "type": data.type,
            "managedLocations":data.managedLocations,
            "managedRoles":data.managedRoles,
            "includeInReports":data.includeInReports,
            "signature":data.signature,
    }});
    const response = await editEmployeeById(body);
    if (response.ok) {
    } else {
        error ="Error editCompanyEmployeeByIdHandler";
    }
    return {
        data: {
            error: error,
            message: response.data.message
        }
        // data: {
        //     error: error,
        //     message: "Success"
        // }
    };
}

export const removeDeviceIdFromEmployeeHandler = async (employeeId, data) => {
    let error = null;
    const body = {
        "deviceId": data.deviceId,
    }
    const response = await CompaniesEmployeeService.removeDeviceIdFromEmployee(employeeId, body);
    if (response.ok) {

    } else {
        error ="Error editServiceProviderHandler";
    }
    return {
        data: {
            error: error
        }
    };
}













